import React from 'react';
import OakAlternativesImg from '../../assets/images/oak_alternative_bg_removed.png'
import { useTranslation } from 'react-i18next';
import './OakAlternatives.css'
function OakAlternatives() {
  const { t } = useTranslation();

  const products = [
  
    {
        name: t('ICEvin DULCIS IN ORE'),
        description: t('Preparation based on parietal polysaccharides with various degrees of hydrolysis obtained from cell walls of Saccharomyces cerevisiae. Add to the wine and carry out two weekly batônnages to reproduce the sur-lies effect.'),
      },
      {
        name: t('ICEvin EASY ROUND'),
        description: t('Adjuvant for red and white wines. It is a preparation based on vegetable polysaccharides, condensed tannins, ellagic tannins and soluble mannoproteins. Its particular composition allows the characteristics of “volume”, “softness” and “flavour” to be enhanced in wines. It should be added to the wines two-three days before bottling.'),
      },
      {
        name: t('ICEvin EQUILIBRIO'),
        description: t('Adjuvant based on proanthocyanidin tannins extracted from the skin and seeds of non-aromatic white grapes rich in medium molecular weight polysaccharides.'),
      },
      {
        name: t('ICEvin FRESH UP'),
        description: t('An ideal adjuvant to rebalance and harmonize the tannic structure of the treated wine, smoothing out sharp edges and increasing elegance and acid perception. The limited astringency makes it a product suitable for addition to white, rosé and red wines, giving aromatic complexity, refreshing and implementing floral and balsamic scents.'),
      },
      {
        name: t('ICEvin LEVANTE'),
        description: t('Fermentation activator based on Saccharomyces cerevisiae yeast autolysate in dried, certified organic form.'),
      },
      {
        name: t('LIOZIMAS Natura DUE yeast'),
        description: t('Fresh culture in liquid form of Saccharomyces cerevisiae yeast cells (phenotypic and genotypic identification periodically checked) indicated for the fermentation of red grape varieties.'),
      },
      {
        name: t('LIOZIMAS Natura UNO yeast'),
        description: t('Fresh culture in liquid form of Saccharomyces cerevisiae yeast cells (phenotypic and genotypic identification periodically checked) indicated for the fermentation of white grape varieties.'),
      },
     
  
  ];

  return (
    <>
   <div className='mainOakAlternativesImg'>
  <div className='OakAlternativesImg1'></div>

  <div className="OakAlternativesImg2">
    <h1 className="OakAlternativesTitle">{t("Oak Alternatives")}</h1>
    <img src={OakAlternativesImg} alt="Oak Alternatives" className="OakAlternativesImage" />
  </div>
</div>
   
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default OakAlternatives;
